export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0-a8d81a006d38d9fcf3f3d76346f09e83.avif";